module.exports = __webpack_public_path__ + "components/country-flag/static/mz-af0d3b44e78d0b87a2ba56594c60f097.svg";